import NimbleMobileLogo from '../../../assets/nimble-navbar-v2-logo-mobile.png';
import NimbleLogoSVG from '../../../assets/nimble-navbar-v2-logo.svg';
import { NimbleLogoProps } from '../types';
import { Stack, styled, Typography } from '@mui/material';

export const PoweredByNimbleLogo: React.FC<NimbleLogoProps> = ({ isMobile }) => {
  const logoToShow = isMobile ? NimbleMobileLogo : NimbleLogoSVG;

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      {isMobile ? (
        <NimbleMobileLogoContainer src={logoToShow} alt="nimbleLogo" />
      ) : (
        <>
          <PoweredByText>Powered by</PoweredByText>
          <StyledLogoContainer src={logoToShow} alt="nimbleLogo" />
        </>
      )}
    </Stack>
  );
};

const PoweredByText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '12.613px',
  fontStyle: 'normal',
  fontWeight: theme.typography.fontWeightMediumBold,
  lineHeight: '18.92px',
}));

const StyledLogoContainer = styled('img')(() => ({
  display: 'flex',
  width: '92.626px',
  height: '25.227px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '5.286px',
}));

export const NimbleMobileLogoContainer = styled('img')(() => ({
  display: 'flex',
  width: '36.129px',
  height: '36.129px',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'white',
}));
